import { render } from "./SoleTraderFormUpdate.vue?vue&type=template&id=a9231d66&scoped=true"
import script from "./SoleTraderFormUpdate.vue?vue&type=script&lang=js"
export * from "./SoleTraderFormUpdate.vue?vue&type=script&lang=js"

import "./SoleTraderFormUpdate.vue?vue&type=style&index=0&id=a9231d66&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a9231d66"]])

export default __exports__